<template>
  <div class="CSChatThai" >
    <Navbar/>
    <div class="page-content page-content-show">



<div class="DocumentPage hidden-sm-and-down">
  <aside class="DocumentPage__menu" style="    overflow: scroll;
    height: 94vh;">
  <div class="DocumentPage__menuGroup js-toggle-group" v-for="(item, index_item) in items" :value="item.active" :key="index_item">
    <h3 class="groupTitle" slot="item" style="text-transform: none;">
      {{ item.title }}
    </h3>
    <ul class="DocumentPage__menuGroupList">

        <router-link tag="li" :to="subItem.link" class="listItem" v-for="(subItem, index) in item.items" :key="index">
          <span  class="active" v-if="active==subItem.link"><i class="fas fa-angle-double-right"></i> {{ subItem.title }}</span>
          <span v-else class="titlehover">{{ subItem.title }}</span>
          <span v-if="subItem.status == 'new'"> <v-icon style="color: #44CD16 !important;    font-size: 20px;">fiber_new</v-icon> </span>
        </router-link>
    </ul>
  </div>
</aside>

  <section class="DocumentPage__content">
  <div class="_make-article">
    <router-view></router-view>
  </div>
</section>

</div>


<div class="hidden-md-and-up">
  <v-layout  style="" row wrap>
    <v-flex xs12 md12 style=" height: auto; padding-top: 14vh; display: flex; justify-content: center; width: 100%; background: #fafafa !important; float: none; border-right: 0;">
      <v-expansion-panel focusable>
        <v-expansion-panel-content
          v-for="(item,index_items) in items"
          :value="item.active"
          :key="index_items"
        >
          <div slot="header" style="font-size: 18px;">{{ item.title }}</div>
          <v-list style="width: 100%;height: auto; padding-left: 0px !important;">
            <v-list-tile v-for="(subItem, index_sub) in item.items" :key="index_sub" @click="link(subItem.link)" >
              <v-list-tile-action style="padding-left: 7vw;">
                <v-icon  outline>{{subItem.icon}}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title style="padding-left: -3vw !important;">{{ subItem.title }}
                  <span v-if="subItem.status == 'new'"> <v-icon style="color: #44CD16 !important;    font-size: 20px;">fiber_new</v-icon> </span>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-flex>
    <v-flex xs12 sm12 >
      <section class="DocumentPage__contentmo">
        <div class="" >
          <router-view ></router-view>
        </div>
      </section>
    </v-flex>
  </v-layout>
 <!-- <a href="#0" class="cd-top js-cd-top">Top</a> -->
</div>








      </div>
  </div>
</template>

<script>
import Navbar from '@/components/home/Navbarapi'
export default {
  components: {
    Navbar
  },
  data: () => ({
    items: [
      {
        action: 'local_activity',
        title: 'เริ่มต้นการใช้งาน',
        active: true,
        items: [
          {title: 'เริ่มต้นการใช้งาน API', link: '/docs', icon: 'info'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'คู่มือการใช้งาน API',
        active: false,
        items: [
          {title: 'การยืนยันตัวตน', link: '/docs/authorization', icon: 'person'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'ข้อมูลเกี่ยวกับบอท',
        active: false,
        items: [
          {title: 'ข้อมูลเพื่อนและกลุ่ม', link: '/docs/aboutbot/getlistroom', icon: 'person'},
          {title: 'ค้นหาข้อมูลเพื่อน', link: '/docs/aboutbot/searchfriend', icon: 'search'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'การส่งข้อความ',
        active: false,
        items: [
          {title: 'การส่งข้อความ', link: '/docs/webhook/reply_message', icon: 'fas fa-comment-alt'},
          {title: 'การส่งข้อความ (หลายห้องแชท)',
            link: '/docs/webhook/message_group_broadcast',
            icon: 'fas fa-comment-alt',
            status: 'new'
          },
          {title: 'การส่งเทมเพลต (หลายห้องแชท)',
            link: '/docs/webhook/template_group_broadcast',
            icon: 'fas fa-comment-alt',
            status: 'new'
          },
          {title: 'การส่งไฟล์', link: '/docs/webhook/reply_file', icon: 'fas fa-file'},
          {title: 'การส่งโลเคชัน', link: '/docs/webhook/reply_location', icon: 'map'},
          {title: 'การส่งสติกเกอร์', link: '/docs/webhook/reply_sticker', icon: 'photo'},
          {title: 'การส่งเว็บวิว', link: '/docs/webhook/reply_webview', icon: 'web'},
          {title: 'การส่งแบบฟอร์มการยืนยัน', link: '/docs/webhook/reply_approve', icon: 'far fa-thumbs-up'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'การส่งเทมเพลต',
        active: false,
        items: [
          {title: 'เกี่ยวกับ Template', link: '/docs/template/abouttemplate', icon: 'info'},
          {title: 'ประเภทข้อความ', link: '/docs/template/template_message', icon: 'chat'},
          {title: 'ประเภทลิงก์', link: '/docs/template/template_link', icon: 'link'},
          {title: 'ประเภทเว็บวิว', link: '/docs/template/template_webview', icon: 'web'},
          {title: 'ประเภทไฟล์', link: '/docs/template/template_file', icon: 'fas fa-file'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'การสร้าง Quick Reply',
        active: false,
        items: [
          {title: 'เกี่ยวกับ Quick Reply', link: '/docs/quickreply/aboutquickreply', icon: 'info'},
          {title: 'ประเภทข้อความ', link: '/docs/quickreply/quickreply_text', icon: 'chat'},
          {title: 'ประเภทลิงก์', link: '/docs/quickreply/quickreply_link', icon: 'link'},
          {title: 'ประเภทเว็บวิว', link: '/docs/quickreply/quickreply_webview', icon: 'web'},
          {title: 'ประเภทเลือกวัน', link: '/docs/quickreply/quickreply_datepicker', icon: 'date_range'},
          {title: 'ประเภทเลือกวันเวลา', link: '/docs/quickreply/quickreply_datetimepicker', icon: 'access_time'},
          {title: 'ประเภทโลเคชัน', link: '/docs/quickreply/quickreply_location', icon: 'location_on' , status: 'new'},
          {title: 'ประเภทรูปภาพ', link: '/docs/quickreply/quickreply_image', icon: 'photo', status: 'new'},
          {title: 'ประเภทไฟล์', link: '/docs/quickreply/quickreply_file', icon: 'fas fa-file', status: 'new'}
          // {title: 'ประเภท OCR', link: '/docs/quickreply/quickreply_ocr', icon: 'qr_code_scanner', status: 'new'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'การสร้าง Bottom Menu',
        active: false,
        status: 'new',
        items: [
          {title: 'การสร้าง Bottom Menu', link: '/docs/bottommeunu/aboutbottommeunu', icon: 'widgets', status: 'new'},
          {title: 'การดึงข้อมูลโดยใช้ onechat_token', link: '/docs/bottommeunu/getprofile', icon: 'account_circle', status: 'new'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'การสร้าง Image Carousel',
        active: false,
        status: 'new',
        items: [
          {title: 'เกี่ยวกับ Image Carousel', link: '/docs/carouselimage/aboutimagecarousel', icon: 'info', status: 'new'},
          {title: 'ประเภทข้อความ', link: '/docs/carouselimage/carouselimage_msg', icon: 'chat'},
          {title: 'ประเภทลิงก์', link: '/docs/carouselimage/carouselimage_link', icon: 'link'},
          {title: 'ประเภทเว็บวิว', link: '/docs/carouselimage/carouselimage_webview', icon: 'web'},
          {title: 'ประเภทรูปภาพ', link: '/docs/carouselimage/carouselimage_image', icon: 'photo'},
          {title: 'ประเภทpostback', link: '/docs/carouselimage/carouselimage_postback', icon: 'web_asset'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'อื่นๆ',
        active: false,
        items: [
          {title: 'การบังคับปิดเว็บวิว', link: '/docs/others/disabled_webview', icon: 'web'},
          {title: 'การเปลี่ยนไปเป็นแป้นพิมพ์', link: '/docs/others/switch_keyboard', icon: 'web'}
        ]
      },
      {
        action: 'far fa-file-code',
        title: 'WebHooks',
        active: false,
        items: [
          {title: 'เกี่ยวกับ webhook', link: '/docs/webhook/aboutwebhook', icon: 'info'},
          {title: 'การรับข้อมูลแบบข้อความ', link: '/docs/webhook/receive_message', icon: 'chat'},
          {title: 'การรับข้อมูลแบบไฟล์ต่างๆ', link: '/docs/webhook/receive_file', icon: 'attach_file'},
          {title: 'การรับข้อมูลแบบโลเคชั่น', link: '/docs/webhook/receive_location', icon: 'location_on'},
          {title: 'การรับข้อมูลแบบสติกเกอร์', link: '/docs/webhook/receive_sticker', icon: 'insert_photo'},
          {title: 'การรับข้อมูลคิวอาร์โค้ดจาก Bottom Menu', link: '/docs/webhook/receive_qrcode', icon: 'qr_code'},
          {title: 'มีการเพิ่มบอทเป็นเพื่อน', link: '/docs/webhook/noti_addbot', icon: 'person_add'},
          {title: 'มีการเพิ่มบอทเข้ากลุ่ม', link: '/docs/webhook/noti_addgroup', icon: 'group_add'},
          {title: 'มีการลบบอทออกจากกลุ่ม', link: '/docs/webhook/noti_leavegroup', icon: 'delete'}
        ]
      }
      // {
      //   action: 'far fa-file-code',
      //   title: 'การตอบกลับข้อความอัตโนมัติ',
      //   active: false,
      //   items: [
      //     {title: 'การเพิ่ม', link: '/docs/reply_message/add', icon: 'add_circle'},
      //     {title: 'การแก้ไข', link: '/docs/reply_message/edit', icon: 'edit'},
      //     {title: 'การลบ', link: '/docs/reply_message/remove', icon: 'delete'},
      //     {title: 'แสดงข้อความทั้งหมด', link: '/docs/reply_message/show', icon: 'list'}
      //   ]
      // }
    ],
    active: '/docs'
    // items: [
    //   {src: '/static/image/ios_photo/ios_friend.png'},
    //   {src: '/static/image/ios_photo/ios_login.png'}
    // ]
  }),
  created () {
    this.active = this.$router.currentRoute.path
  },
  watch: {
    '$route' () {
      this.active = this.$router.currentRoute.path
    }
  },
  methods: {
    link (link) {
      this.$router.push(link)
    }
  }
}
</script>

<style type="text/css" scoped>
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.EndpointNew{
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    font-size: 10px;
    font-weight: bold;
    line-height: 0.5em;
    border-radius: 20px;
    /*border-color: #3cb614;*/
    background-color: #44CD16;
    color: #FFFFFF;
}
.DocumentPage__menuGroup.-is-aritcle-vertioning {
    padding-right: 32px;
}
.DocumentPage {
    max-width: 1040px;
    margin-left: 30px;
    margin-right: auto;

    margin-top: 1px;
    padding-left: 24px;
    padding-right: 24px;
    background-color: #FFFFFF;
}
.DocumentPage__menu {
  position: fixed;
    float: left;
    width: 15%;
    padding-top: 18vh;
    padding-bottom: 48px;
}
article, aside, details, figcaption, figure, footer, header, main, menu, nav, section, summary {
    display: block;
}
.DocumentPage__menuGroup {
    position: relative;
    margin-bottom: 40px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.DocumentPage__menuGroupList {
    margin: 0;
    padding: 0;
}
.DocumentPage__menuGroupList>.listItem {
    position: relative;
    margin-bottom: 15px;
    list-style: none;
    color: #1976D2;
    cursor: pointer;
}
.active {
    color: #636363;
}
.DocumentPage__menuGroup>.groupTitle {
    position: relative;
    margin-bottom: 8px;
    color: #04070D;
    font-size: 12px;
    text-transform: none;
}
.DocumentPage__content {
    float: left;
    width: 73%;
    margin-left: 17vw;
    padding-top: 67px;
    /*/*padding-left: 40px;*/
    padding-right: 1px;
    padding-bottom: 48px;
}
.DocumentPage__contentmo {
   float: left;
    width: 73%;
    margin-left: 5vw;
    /*/*padding-left: 40px;*/
    padding-right: 1px;
    padding-bottom: 48px;
    /*overflow-x: hidden;*/
}
._make-article {
    line-height: 1.5em;
}
.DocumentPage .ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
.CustomSelectBox {
    position: relative;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
>>>.list--group .list__tile {
    padding-left: 7vw;
}
.titlehover:hover {
  color: #4da7ff;
}

::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  /* background: #1b232d; */
  background:rgba(230, 230, 230,0.2);
}

::-webkit-scrollbar-thumb {
  /* background: #888; */
  background-color: rgba(137, 137, 139, 0.2);
  border-radius: 10px;
}

/* body {
    scrollbar-face-color: #b46868;
} */

</style>



// WEBPACK FOOTER //
// src/components/home/API.vue